<template>
  <b-card no-body class="mb-1" v-if="this.currentUser.info.role_id == 3">
    <b-card-header header-tag="header" class="p-3" role="tab">
      <span class="m-1">Data Pekerjaan dan Penghasilan</span>
      <b-button v-b-toggle.accordion-3 variant="yellow" class="chevron">
        <span class="when-open">
          <b-icon icon="chevron-up" />
        </span>
        <span class="when-closed">
          <b-icon icon="chevron-down" />
        </span>
      </b-button>
    </b-card-header>

    <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-card-text>
          <div class="container">
            <b-alert v-if="sectionRejectionMessages.length > 0" show variant="warning" class="mb-4">
              <b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>
              <strong>Berdasarkan hasil verifikasi, pengajuan saat ini belum dapat disetujui.</strong>
              <div v-for="(msg, idx) in sectionRejectionMessages" :key="idx" class="mt-2 ml-4">
                <p class="mb-1"><strong>Alasan:</strong> {{ msg.note }}</p>
                <div v-if="msg.fields && msg.fields.length > 0">
                  <p class="mb-0"><strong>Data atau informasi yang memerlukan perbaikan (Data Pekerjaan):</strong></p>
                  <ol class="mb-2">
                  <li v-for="f in msg.fields" :key="f.field" class="font-weight-bold">{{ f.label }}</li>
                  </ol>
                </div>
              </div>
              <hr v-if="sectionRejectionMessages.length > 0">
              <p class="mt-2 mb-0">Untuk dapat melakukan pengajuan kembali mohon dapat memperbarui data pekerjaan anda pada kolom yang berwarna merah di bawah ini.</p>
            </b-alert>

            <div v-if="loadingPekerjaan" class="text-center my-4">
              <b-spinner label="Loading..." variant="primary" small></b-spinner>
              <p>Memuat data, mohon tunggu...</p>
            </div>
            <b-form v-else @submit.prevent="updatePekerjaan">
              <div class="row">
                <span style="font-size: 12px;">Note : (*) Wajib diisi</span>
              </div>
              <div class="row">
                <div class="col">
                  <div class="jenis_pekerjaan">
                    <label for="jenis_pekerjaan" :class="{'text-danger font-weight-bold': allRejectedFields.includes('jenis_pekerjaan')}">Jenis Pekerjaan *</label>
                    <br />
                    <b-form-select required v-model="pekerjaan.jenis_pekerjaan" :value.sync="pekerjaan.jenis_pekerjaan" :options="options_pekerjaan.jenis_pekerjaan" @input="jenisPekerjaanChange" :class="{'is-invalid border-danger': allRejectedFields.includes('jenis_pekerjaan')}"></b-form-select>
                  </div>
                </div>
              </div>
              <div v-if="pekerjaan.jenis_pekerjaan == 'Pegawai Swasta / BUMN' || pekerjaan.jenis_pekerjaan == 'Aparatur Sipil Negara'" class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fname" :class="{'text-danger font-weight-bold': allRejectedFields.includes('jabatan')}">Jabatan *</label>
                    <br />
                    <b-form-input
                      v-model="pekerjaan.jabatan"
                      placeholder="Masukan nama tempat kerja"
                      :class="{'is-invalid border-danger': allRejectedFields.includes('jabatan')}"
                      :disabled="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                                pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                                pekerjaan.jenis_pekerjaan == 'Guru / Dosen' ||
                                pekerjaan.jenis_pekerjaan == 'Pelajar' ||
                                pekerjaan.jenis_pekerjaan == 'Ibu Rumah Tangga' ||
                                pekerjaan.jenis_pekerjaan == 'Mahasiswa' ||
                                pekerjaan.jenis_pekerjaan == 'Pedagang' ||
                                pekerjaan.jenis_pekerjaan == 'Pensiunan' ||
                                pekerjaan.jenis_pekerjaan == 'Petani' ||
                                pekerjaan.jenis_pekerjaan == 'Lainnya'"
                      :required="isJabatanRequired"
                    ></b-form-input>

                  </div>
                </div>
              </div>
              <div v-if="pekerjaan.jenis_pekerjaan == 'Wiraswasta'" class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="bidang_usaha" :class="{'text-danger font-weight-bold': allRejectedFields.includes('bidang_usaha_id')}">Bidang Usaha *</label>
                    <br />
                    <b-form-select
                      :required="isBidangUsahaRequired"
                      v-model="pekerjaan.bidang_usaha_id"
                      id="bidang_usaha"
                      :value.sync="pekerjaan.bidang_usaha_id"
                      :options="options_pekerjaan.bidang_usaha_id"
                      :disabled="!isBidangUsahaRequired"
                      :class="{'is-invalid border-danger': allRejectedFields.includes('bidang_usaha_id')}"
                      @input="bidangUsahaPekerjaanChange"
                    />

                  </div>
                </div>
              </div>
              <div class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fname" :class="{'text-danger font-weight-bold': allRejectedFields.includes('nama_tempatkerja')}">Nama Tempat Usaha / Perusahaan / Instansi *</label>
                    <br />
                    <b-form-input v-model="pekerjaan.nama_tempatkerja" placeholder="Masukan nama tempat kerja" :disabled="jenisPekerjaan" :class="{'is-invalid border-danger': allRejectedFields.includes('nama_tempatkerja')}" :required="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Pegawai Swasta / BUMN' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Aparatur Sipil Negara' ||
                      pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                      pekerjaan.jenis_pekerjaan == 'Guru / Dosen'
                      "></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fname" :class="{'text-danger font-weight-bold': allRejectedFields.includes('alamat_tempatkerja')}">Alamat Tempat Usaha / Perusahaan / Instansi *</label>
                    <br />
                    <b-form-input :required="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Pegawai Swasta / BUMN' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Aparatur Sipil Negara' ||
                      pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                      pekerjaan.jenis_pekerjaan == 'Guru / Dosen'
                      " v-model="pekerjaan.alamat_tempatkerja" placeholder="Masukan alamat tempat bekerja" :disabled="jenisPekerjaan" :class="{'is-invalid border-danger': allRejectedFields.includes('alamat_tempatkerja')}"></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="provinsi">Provinsi *</label>
                    <br />
                    <b-form-select :required="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Pegawai Swasta / BUMN' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Aparatur Sipil Negara' ||
                      pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                      pekerjaan.jenis_pekerjaan == 'Guru / Dosen'
                      " v-model="pekerjaan.provinsi" id="provinsi" :value.sync="pekerjaan.provinsi" :options="options_pekerjaan.provinsi" :disabled="jenisPekerjaan" @input="provinsiPekerjaanChange" :class="{'is-invalid border-danger': allRejectedFields.includes('identity_province_id') || allRejectedFields.includes('provinsi')}"></b-form-select>
                  </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="exampleFormControlSelect7">Kota / Kabupaten *</label>
                    <br />
                    <b-form-select :required="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Pegawai Swasta / BUMN' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Aparatur Sipil Negara' ||
                      pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                      pekerjaan.jenis_pekerjaan == 'Guru / Dosen'
                      " v-model="pekerjaan.kota" :value.sync="pekerjaan.kota" :options="options_pekerjaan.kota" @input="kotaPekerjaanChange" :disabled="jenisPekerjaan || loadingchangeProvince" :class="{'is-invalid border-danger': allRejectedFields.includes('identity_city_id') || allRejectedFields.includes('kota')}"></b-form-select>
                    <small
                      v-if="loadingchangeProvince"
                      class="text-muted d-block mt-1"
                      style="font-size: 11px;"
                    >
                      <b-spinner small type="grow" class="mr-1" style="width: 0.8rem; height: 0.8rem;"></b-spinner>
                      memuat data kota...
                    </small>  
                </div>
                </div>
              </div>

              <div class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="kecamatan">Kecamatan *</label>
                    <br />
                    <b-form-select :required="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Pegawai Swasta / BUMN' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Aparatur Sipil Negara' ||
                      pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                      pekerjaan.jenis_pekerjaan == 'Guru / Dosen'
                      " v-model="pekerjaan.kecamatan" :value.sync="pekerjaan.kecamatan" :options="options_pekerjaan.kecamatan" @input="kecamatanPekerjaanChange" :disabled="jenisPekerjaan || loadingKotaChange" :class="{'is-invalid border-danger': allRejectedFields.includes('identity_district_id') || allRejectedFields.includes('kecamatan')}"></b-form-select>
                    <small
                      v-if="loadingKotaChange"
                      class="text-muted d-block mt-1"
                      style="font-size: 11px;"
                    >
                      <b-spinner small type="grow" class="mr-1" style="width: 0.8rem; height: 0.8rem;"></b-spinner>
                      memuat data kecamatan...
                    </small>  
                </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="desa">Desa / Kelurahan *</label>
                    <br />
                    <b-form-select :required="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Pegawai Swasta / BUMN' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Aparatur Sipil Negara' ||
                      pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                      pekerjaan.jenis_pekerjaan == 'Guru / Dosen'
                      " v-model="pekerjaan.kelurahan" :value.sync="pekerjaan.kelurahan" :options="options_pekerjaan.kelurahan" :disabled="jenisPekerjaan || loadingKecamatanChange" :class="{'is-invalid border-danger': allRejectedFields.includes('identity_sub_district_id') || allRejectedFields.includes('kelurahan')}"></b-form-select>
                    <small
                      v-if="loadingKecamatanChange"
                      class="text-muted d-block mt-1"
                      style="font-size: 11px;"
                    >
                      <b-spinner small type="grow" class="mr-1" style="width: 0.8rem; height: 0.8rem;"></b-spinner>
                      memuat data kelurahan...
                    </small>  
                </div>
                </div>
              </div>

              <div class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fname">Kode Pos *</label>
                    <br />
                    <b-form-input :required="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Pegawai Swasta / BUMN' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Aparatur Sipil Negara' ||
                      pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                      pekerjaan.jenis_pekerjaan == 'Guru / Dosen'
                      " v-model="pekerjaan.kode_pos" placeholder="Masukan kode pos" :disabled="jenisPekerjaan" :class="{'is-invalid border-danger': allRejectedFields.includes('postcode') || allRejectedFields.includes('kode_pos')}"></b-form-input>
                  </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fname">Negara *</label>
                    <br />
                    <b-form-input :required="pekerjaan.jenis_pekerjaan == 'Wiraswasta' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Pegawai Swasta / BUMN' ||
                      pekerjaan.jenis_pekerjaan ==
                      'Aparatur Sipil Negara' ||
                      pekerjaan.jenis_pekerjaan == 'TNI / POLRI' ||
                      pekerjaan.jenis_pekerjaan == 'Guru / Dosen'
                      " v-model="pekerjaan.negara" placeholder="Masukan negara" :disabled="jenisPekerjaan"></b-form-input>
                  </div>
                </div>
              </div>

              <div class="row ">
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fname" :class="{'text-danger font-weight-bold': allRejectedFields.includes('no_telpon')}">No. Telp Tempat Usaha / Perusahaan / Instansi</label>
                    <br />
                    <b-form-input 
                    v-model="pekerjaan.no_telpon" type="number" placeholder="Masukan No telpon kantor" :disabled="jenisPekerjaan" :class="{'is-invalid border-danger': allRejectedFields.includes('no_telpon')}"></b-form-input>
                  </div>
                </div>
                <div class="col">
                  <div class="alamat mt-3">
                    <label for="fname" :class="{'text-danger font-weight-bold': allRejectedFields.includes('ratarata_penghasilan_perbulan')}">Rata-rata Penghasilan dalam 1 Bulan *</label>
                    <br />
                    <b-form-radio-group v-model="pekerjaan.ratarata_penghasilan_perbulan" :options="options_pekerjaan.penghasilan_perbulan" :class="{'is-invalid border-danger': allRejectedFields.includes('ratarata_penghasilan_perbulan')}" required></b-form-radio-group>
                  </div>
                </div>
              </div>
              <div class="alamat mt-4 mb-3">
                <button
                  type="submit"
                  class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0"
                  :disabled="hasUnresolvedSectionRejection"
                  :title="hasUnresolvedSectionRejection ? 'Perbaiki semua data yang ditolak terlebih dahulu' : ''"
                >
                  Simpan Data Pekerjaan
                </button>
              </div>
            </b-form>
          </div>

          <!-- Update pekerjaan confirmation modal -->
          <b-modal size="m" v-model="confirmPekerjaanModal" hide-footer hide-header>
            <div class="d-block text-center">
              <h3>Apakah Anda yakin?</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block @click="confirmUpdatePekerjaan" :disabled="loading">
                  <b-spinner small v-if="loading"></b-spinner>
                  <span v-else>Ya</span>
                </b-button>
              </div>
              <div class="col">
                <b-button class="mt-3" block @click="confirmPekerjaanModal = false" :disabled="loading">
                  Tidak
                </b-button>
              </div>
            </div>
            <!-- Pesan error jika update gagal -->
            <div v-if="errorMessage" class="text-danger text-center mt-2">
              {{ errorMessage }}
            </div>
          </b-modal>

          <!-- Success modal for all confirmation  -->
          <b-modal size="m" v-model="successModal" hide-footer hide-header>
            <div class="d-block text-center">
              <b-icon icon="check-circle" animation="throb" variant="success" style="width: 120px; height: 120px;"></b-icon>
              <h3>{{ modalText }}</h3>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="mt-3" block @click="successModal = false">Tutup</b-button>
              </div>
            </div>
          </b-modal>
        </b-card-text>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import BidangUsaha from "../../api/bidangusaha";
import Pekerjaan from "../../api/pekerjaan";
import Funder from "../../api/funder.js";
import Provinsi from "../../api/daerahindonesia/provinsi";
import Kecamatan from "../../api/daerahindonesia/kecamatan";
import Kelurahan from "../../api/daerahindonesia/kelurahan";
import Kota from "../../api/daerahindonesia/kota";
import Pengajuan from "../../api/pengajuan.js";

export default {
  name: "DataPekerjaan",
  props: {
    allRejectedFields: {
      type: Array,
      default: () => []
    },
    rejectionMessages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pekerjaan: {
        user_id: null,
        nama_tempatkerja: "",
        bidang_usaha_id: "",
        alamat_tempatkerja: "",
        jabatan: "",
        lama_bekerja: "",
        provinsi: null,
        kota: null,
        kecamatan: null,
        kelurahan: null,
        kode_pos: "",
        negara: "",
        no_telpon: "",
        ratarata_penghasilan_perbulan: "",
        jenis_pekerjaan: ""
      },
      options_pekerjaan: {
        provinsi: [],
        kota: [],
        kecamatan: [],
        kelurahan: [],
        bidang_usaha_id: [
        { text: "Elektronik", value: "Elektronik" },
        { text: "Event Organizer", value: "Event Organizer" },
        { text: "Finansial", value: "Finansial" },
        { text: "Hiburan", value: "Hiburan" },
        { text: "Kehutanan", value: "Kehutanan" },
        { text: "Kerajinan Tangan", value: "Kerajinan Tangan" },
        { text: "Kesehatan & Gaya Hidup", value: "Kesehatan & Gaya Hidup" },
        { text: "Konsultan", value: "Konsultan" },
        { text: "Kontraktor", value: "Kontraktor" },
        { text: "Konstruksi", value: "Konstruksi" },
        { text: "Layanan Rumah", value: "Layanan Rumah" },
        { text: "Layanan Pribadi", value: "Layanan Pribadi" },
        { text: "Logistik", value: "Logistik" },
        { text: "Makanan & Minuman", value: "Makanan & Minuman" },
        { text: "Manufaktur", value: "Manufaktur" },
        { text: "Migas", value: "Migas" },
        {
          text: "Olahraga/ Wahana Olahraga",
          value: "Olahraga/ Wahana Olahraga",
        },
        { text: "Otomotif", value: "Otomotif" },
        { text: "Pendidikan", value: "Pendidikan" },
        { text: "Penginapan", value: "Penginapan" },
        { text: "Pertanian", value: "Pertanian" },
        { text: "Pertambangan", value: "Pertambangan" },
        { text: "Peternakan", value: "Peternakan" },
        { text: "Perikanan", value: "Perikanan" },
        { text: "Periklanan", value: "Periklanan" },
        { text: "Properti", value: "Properti" },
        { text: "Retail", value: "Retail" },
        { text: "Teknologi & IT", value: "Teknologi & IT" },
        { text: "Tekstil/ Garmen", value: "Tekstil/ Garmen" },
        { text: "Telekomunikasi", value: "Telekomunikasi" },
        { text: "Travel", value: "Travel" },
        { text: "Transportasi", value: "Transportasi" },
        ],
        jenis_pekerjaan: [
          { text: "Wiraswasta", value: "Wiraswasta" },
          { text: "Pegawai Swasta / BUMN", value: "Pegawai Swasta / BUMN" },
          { text: "Aparatur Sipil Negara", value: "Aparatur Sipil Negara" },
          { text: "TNI / POLRI", value: "TNI / POLRI" },
          { text: "Guru / Dosen", value: "Guru / Dosen" },
          { text: "Pelajar", value: "Pelajar" },
          { text: "Ibu Rumah Tangga", value: "Ibu Rumah Tangga" },
          { text: "Mahasiswa", value: "Mahasiswa" },
          { text: "Pedagang", value: "Pedagang" },
          { text: "Pensiunan", value: "Pensiunan" },
          { text: "Petani", value: "Petani" },
          { text: "Lainnya", value: "Lainnya" }
        ],
        penghasilan_perbulan: [
          {
            text: "Rp. < Rp. 1.000.000",
            value: "Rp. < Rp. 1.000.000"
          },
          {
            text: "Rp. 1.000.000 - Rp. 2.500.000",
            value: "Rp. 1.000.000 - Rp. 2.500.000"
          },
          {
            text: "Rp. 2.500.000 - Rp. 5.000.000",
            value: "Rp. 2.500.000 - Rp. 5.000.000"
          },
          {
            text: "Rp. 5.000.000 - Rp. 7.500.000",
            value: "Rp. 5.000.000 - Rp. 7.500.000"
          },
          {
            text: "Rp. 7.500.000 - Rp. 10.000.000",
            value: "Rp. 7.500.000 - Rp. 10.000.000"
          },
          {
            text: "Rp. > Rp. 10.000.000",
            value: "Rp. > Rp. 10.000.000"
          }
        ]
      },
      confirmPekerjaanModal: false,
      modalText: "",
      successModal: false,
      errorMessage: "",
      loading: false,
      requir: false,
      loadingPekerjaan: false,
      originalPekerjaan: {},

      //loadings 
      loadingchangeProvince: false,
      loadingKotaChange: false,
      loadingKecamatanChange: false
    };
  },
  mounted() {
    // console.log("data kerja", this.options_pekerjaan.bidang_usaha);
    // console.log("data usaha", this.pekerjaan.jenis_pekerjaan);
    this.loadData();
  },
  computed: {
    hasUnresolvedSectionRejection() {
      return this.sectionRejectionMessages.some(msg => msg.fields && msg.fields.length > 0);
    },
    sectionRejectionMessages() {
      if (!this.rejectionMessages) return [];
      
      return this.rejectionMessages.map(msg => {
        const filteredFields = msg.fields ? msg.fields.filter(f => {
          const model = (f.model || '').trim().toLowerCase();
          return model === 'datapekerjaan';
        }) : [];

        if (filteredFields.length > 0) {
          return {
            note: msg.note,
            fields: filteredFields
          };
        }
        return null;
      }).filter(msg => msg !== null);
    },
    isJabatanRequired() {
      return this.pekerjaan.jenis_pekerjaan == 'Pegawai Swasta / BUMN' ||
            this.pekerjaan.jenis_pekerjaan == 'Aparatur Sipil Negara';
    },
    isBidangUsahaRequired() {
      return this.pekerjaan.jenis_pekerjaan == 'Wiraswasta';
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    jenisPekerjaan() {
      if (
        this.pekerjaan.jenis_pekerjaan == "Pelajar" ||
        this.pekerjaan.jenis_pekerjaan == "Ibu Rumah Tangga" ||
        this.pekerjaan.jenis_pekerjaan == "Mahasiswa" ||
        this.pekerjaan.jenis_pekerjaan == "Pedagang" ||
        this.pekerjaan.jenis_pekerjaan == "Pensiunan" ||
        this.pekerjaan.jenis_pekerjaan == "Petani" ||
        this.pekerjaan.jenis_pekerjaan == "Lainnya"
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    pekerjaan: {
      handler(newVal) {
        if (this.loadingPekerjaan || !this.originalPekerjaan) return;
        this.allRejectedFields.forEach(field => {
          if (newVal[field] !== this.originalPekerjaan[field]) {
            this.$emit('dirty', field);
          }
        });
      },
      deep: true
    }
  },
  methods: {
    async loadData() {
    this.loadingPekerjaan = true; // 🔵 MULAI loading

    try {
      const res = await Funder.showJob(this.currentUser.info.id);
      let userPekerjaan = res.data.data.data_pekerjaan;
      this.pekerjaan = userPekerjaan;
      this.originalPekerjaan = JSON.parse(JSON.stringify(userPekerjaan || {}));

      // 🔹 Get Provinsi
      const responseProvinsi = await this.$getListWilayah('provinsi');
      const provinsiArray = responseProvinsi.data || [];
      this.options_pekerjaan.provinsi = provinsiArray.map(item => ({
        value: item.id,
        text: item.name
      }));

      // 🔹 Get Kota
      if (this.pekerjaan.provinsi) {
        const responseKota = await this.$getListWilayah('kota', this.pekerjaan.provinsi);
        const kotaArray = responseKota.data || [];
        this.options_pekerjaan.kota = kotaArray.map(item => ({
          value: item.id,
          text: item.name
        }));
      }

      // 🔹 Get Kecamatan
      if (this.pekerjaan.kota) {
        const responseKecamatan = await this.$getListWilayah('kecamatan', this.pekerjaan.kota);
        const kecamatanArray = responseKecamatan.data || [];
        this.options_pekerjaan.kecamatan = kecamatanArray.map(item => ({
          value: item.id,
          text: item.name
        }));
      }

      // 🔹 Get Kelurahan
      if (this.pekerjaan.kecamatan) {
        const responseKelurahan = await this.$getListWilayah('kelurahan', this.pekerjaan.kecamatan);
        const kelurahanArray = responseKelurahan.data || [];
        this.options_pekerjaan.kelurahan = kelurahanArray.map(item => ({
          value: item.id,
          text: item.name
        }));
      }

      // 🔹 Get Bidang Usaha
      const bidangRes = await BidangUsaha.index();
      const resData = bidangRes.data.data.data || [];
      this.options_pekerjaan.bidang_usaha = resData.map(item => ({
        value: item.id,
        text: item.name
      }));

    } catch (err) {
      console.error("Gagal memuat data pekerjaan:", err);
    } finally {
      this.loadingPekerjaan = false; // 🟢 SELESAI loading
    }
  },

    updateDataPekerjaan() { },

    bidangUsahaPekerjaanChange() {
      // console.log("Bidang usaha changed:", this.pekerjaan.bidang_usaha_id);
    },

    jenisPekerjaanChange() {
      // console.log(this.pekerjaan.jenis_pekerjaan);
      const arrData = [];
      if (
        this.pekerjaan.jenis_pekerjaan == "Pelajar" ||
        this.pekerjaan.jenis_pekerjaan == "Ibu Rumah Tangga" ||
        this.pekerjaan.jenis_pekerjaan == "Mahasiswa" ||
        this.pekerjaan.jenis_pekerjaan == "Pedagang" ||
        this.pekerjaan.jenis_pekerjaan == "Pensiunan" ||
        this.pekerjaan.jenis_pekerjaan == "Petani" ||
        this.pekerjaan.jenis_pekerjaan == "Lainnya"
      ) {
        this.pekerjaan.jabatan = "";
        this.pekerjaan.bidang_usaha_id = "";
        this.pekerjaan.nama_tempatkerja = "";
        this.pekerjaan.alamat_tempatkerja = "";
        this.pekerjaan.provinsi = "";
        this.pekerjaan.kota = "";
        this.pekerjaan.kecamatan = "";
        this.pekerjaan.kelurahan = "";
        this.pekerjaan.kode_pos = "";
        this.pekerjaan.negara = "";
        this.pekerjaan.no_telpon = "";
        this.requir = false;
      }
      if (this.pekerjaan.jenis_pekerjaan == "Pegawai Swasta / BUMN" || this.pekerjaan.jenis_pekerjaan == 'Aparatur Sipil Negara') {
        this.pekerjaan.bidang_usaha_id = "";
      } else if (this.pekerjaan.jenis_pekerjaan == "Wiraswasta") {
        this.pekerjaan.jabatan = "";
      }
    },

    async provinsiPekerjaanChange() {
      this.loadingchangeProvince = true;
      try {
        const responseKota = await this.$getListWilayah('kota', this.pekerjaan.provinsi);
          const kotaArray = responseKota.data || [];
          const arrData = kotaArray.map(item => ({
            value: item.id,
            text: item.name
          }));
          this.options_pekerjaan.kota = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingchangeProvince = false;
      }
    },

    async kotaPekerjaanChange() {
      this.loadingKotaChange = true;
      try {
        const responseKecamatan = await this.$getListWilayah('kecamatan', this.pekerjaan.kota);
          const kecamatanArray = responseKecamatan.data || [];
          const arrData = kecamatanArray.map(item => ({
            value: item.id,
            text: item.name
          }));
          this.options_pekerjaan.kecamatan = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKotaChange = false;
      }
    },

    async kecamatanPekerjaanChange() {
      this.loadingKecamatanChange = true;
      try {
        const responseKelurahan = await this.$getListWilayah('kelurahan', this.pekerjaan.kecamatan);
          const kelurahanArray = responseKelurahan.data || [];
          const arrData = kelurahanArray.map(item => ({
            value: item.id,
            text: item.name
          }));
          this.options_pekerjaan.kelurahan = arrData;
      } catch (error) {
        console.error("Error in provinsiChangeKtp:", error);
      } finally {
        this.loadingKecamatanChange = false;
      }
    },

    updatePekerjaan() {
      this.confirmPekerjaanModal = true;
    },

    confirmUpdatePekerjaan() {
      this.loading = true;
      this.errorMessage = "";

      // Normalisasi nomor telepon
      if (this.pekerjaan.no_telpon) {
        if (this.pekerjaan.no_telpon.startsWith("08")) {
          this.pekerjaan.no_telpon = "628" + this.pekerjaan.no_telpon.slice(2);
        } else if (this.pekerjaan.no_telpon.startsWith("02")) {
          this.pekerjaan.no_telpon = "622" + this.pekerjaan.no_telpon.slice(2);
        }
        // kalau sudah 62 biarkan saja
      }

      const payload = Object.fromEntries(
        Object.entries(this.pekerjaan).map(([key, value]) => {
          if (value === "" || value === undefined) {
            return [key, null];
          }
          return [key, value];
        })
      );

      Pekerjaan.update(payload)
        .then(res => {
          if (res.data.meta.code === 200) {
            this.confirmPekerjaanModal = false;
            this.successModal = true;
            this.modalText = "Data pekerjaan berhasil diperbarui";
            this.$emit('updated'); // Pemicu pembersihan alert di parent
          } else if (res.data.meta.code === 422) {
            const errors = res.data.data; // ambil object field error dinamis

            if (errors && typeof errors === "object") {
              this.errorMessage = Object.entries(errors)
                .map(([field, messages]) => {
                  // pastikan messages selalu array, jika null/undefined jadikan array kosong
                  const msgs = Array.isArray(messages) ? messages : [];
                  return msgs.map(msg => `${msg}`).join("\n");
                })
                .filter(line => line) // hapus line kosong
                .join("\n");
            } else {
              this.errorMessage = "Data belum lengkap, mohon periksa kembali pengisian data Anda.";
            }

          } else {
            this.errorMessage = res.data.meta.messages ? res.data.meta.messages : "Terjadi kesalahan.";
          }
        })
        .catch(err => {
          this.errorMessage = "Terjadi kesalahan saat memperbarui data.";
          console.error("Error:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.collapsed>.when-open,
.not-collapsed>.when-closed {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/DataPekerjaan.vue